// MyLeavesPage.jsx — 직원 본인 연차 wrapper page (Step 4 신규)
//
// 목적: LeavesSection을 별도 라우트(/my/leaves)에서 렌더하기 위한 wrapper
// 회귀 zero 원칙: useDashboardBase + useLeaveCalcs 그대로 호출 (Dashboard.jsx와 동일 데이터)
//
// 작성: 2026-04-27, dashboard-layout-migration Step 4
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../components/Toast';
import LeavesSection from '../../features/leaves/LeavesSection';
import { useDashboardBase } from '../dashboard/useDashboardBase';
import { useLeaveCalcs } from '../dashboard/useLeaveCalcs';
import { fmtDate, weekdayOne, matchesLeaveFilter } from '../dashboard/utils';
import { usePermissions } from '../../hooks/usePermissions';

export default function MyLeavesPage() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const base = useDashboardBase({ navigate, showToast });
  const { leaveFilterDefs, leaveSummaryStats, leaveSummaryPresence, filteredLeaveRows } = useLeaveCalcs({
    leaveList: base.leaveData.list, activeLeaveFilters: base.activeLeaveFilters,
  });

  const permissions = usePermissions({
    permCodes: base.permCodesSet,
    taskCodes: base.taskCodes,
    featureSetNames: base.featureSetNames,
    workerType: base.me?.workerType,
    externalCompany: base.me?.externalCompany,
  });

  // 진입 시 최초 1회 로드 (Dashboard.jsx의 menu === 'leaves' useEffect와 동일)
  useEffect(() => {
    if (!permissions.canUseMyLeaves) return;
    if (!base.leaveLoaded) base.fetchLeaveAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base.leaveLoaded, permissions.canUseMyLeaves]);

  if (base.permissionsLoaded && !permissions.canUseMyLeaves) {
    return <div style={{ padding: 24, color: 'var(--text-muted)' }}>연차 권한이 없습니다.</div>;
  }

  return (
    <LeavesSection
      leaveLoading={base.leaveLoading} leaveData={base.leaveData}
      leaveSummaryStats={leaveSummaryStats} filteredLeaveRows={filteredLeaveRows}
      leaveSummaryPresence={leaveSummaryPresence}
      activeLeaveFilters={base.activeLeaveFilters} expandedLeave={base.expandedLeave}
      leaveFilterDefs={leaveFilterDefs}
      fmtDate={fmtDate} weekdayOne={weekdayOne}
      matchesLeaveFilter={matchesLeaveFilter}
      onToggleFilter={(filterKey) => base.setActiveLeaveFilters((prev) =>
        prev.includes(filterKey) ? prev.filter((x) => x !== filterKey) : [...prev, filterKey]
      )}
      onToggleDetail={(key) => base.setExpandedLeave((prev) => ({ ...prev, [key]: !prev[key] }))}
    />
  );
}
